/* eslint-disable sort-keys */
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LcsApiService, LoadingState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import {
   AccountNameSearchApiResult,
   MacAddressSearchApiResult,
   PhoneNumberSearchApiResult,
   SoftphoneUsernameSearchApiResult,
} from '../models/global-search-result-api.model';
import { GlobalSearchResultSet } from '../models/global-search.model';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
   public maxResults = 50;

   private accountFields = ['AccountId', 'Name', 'ShortName'];

   private deviceFields = ['Account.Name', 'DeviceId', 'MacAddress', 'DeviceType'];

   private phoneNumberFields = ['Account.Name', 'PhoneNumberId', 'PhoneNumber'];

   private softphoneUsernameFields = [
      'Account.Name',
      'Phone.Extension.ExtensionId',
      'Phone.Extension.Number',
      'Username',
   ];

   constructor(private httpClient: HttpClient, private apiService: LcsApiService) {}

   hasDynamicData(resultset: GlobalSearchResultSet): boolean {
      const hasDynamicData =
         resultset.data.accounts?.length > 0 ||
         resultset.data.devices?.length > 0 ||
         resultset.data.phoneNumbers?.length > 0 ||
         resultset.data.softphoneUsernames?.length > 0;
      return hasDynamicData;
   }

   isLoading(resultset: GlobalSearchResultSet): boolean {
      const isLoading =
         resultset.callStates.accounts === LoadingState.Loading ||
         resultset.callStates.devices === LoadingState.Loading ||
         resultset.callStates.phoneNumbers === LoadingState.Loading ||
         resultset.callStates.softphoneUsernames === LoadingState.Loading;
      return isLoading;
   }

   searchAccountNames(searchText: string): Observable<HttpResponse<AccountNameSearchApiResult[]>> {
      searchText = this.formatSearchText(searchText);
      let url = `${this.apiService.apiUrl}/GlobalSearch/ExecuteAccountSearch?searchText=${searchText}`;
      url = url + '&fields=' + this.accountFields.join(',');
      return this.httpClient.get<AccountNameSearchApiResult[]>(url, { observe: 'response' });
   }

   searchDevices(searchText: string): Observable<HttpResponse<MacAddressSearchApiResult[]>> {
      searchText = this.formatSearchText(searchText);
      let url = `${this.apiService.apiUrl}/GlobalSearch/ExecuteDeviceSearch?searchText=${searchText}`;
      url = url + '&fields=' + this.deviceFields.join(',');

      return this.httpClient.get<MacAddressSearchApiResult[]>(url, { observe: 'response' });
   }

   searchPhoneNumbers(searchText: string): Observable<HttpResponse<PhoneNumberSearchApiResult[]>> {
      searchText = this.formatSearchText(searchText);
      let url = `${this.apiService.apiUrl}/GlobalSearch/ExecutePhoneNumberSearch?searchText=${searchText}`;
      url = url + '&fields=' + this.phoneNumberFields.join(',');

      return this.httpClient.get<PhoneNumberSearchApiResult[]>(url, { observe: 'response' });
   }

   searchSoftPhoneUserNames(searchText: string): Observable<HttpResponse<SoftphoneUsernameSearchApiResult[]>> {
      searchText = this.formatSearchText(searchText);
      let url = `${this.apiService.apiUrl}/GlobalSearch/ExecuteSoftphoneUsernameSearch?searchText=${searchText}`;
      url = url + '&fields=' + this.softphoneUsernameFields.join(',');

      return this.httpClient.get<SoftphoneUsernameSearchApiResult[]>(url, { observe: 'response' });
   }

   private formatSearchText(searchText: string): string {
      return searchText.replace(/\\/g, '');
   }
}
